import React from "react"

function Footer() {
  return (
    <div className='mx-auto sticky text-center'>
      <h1>designed and developed by TheTruthAboutTreasure</h1>
    </div>
  )
}

export default Footer
